import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Admin/auth requests need cookies for the session token
export const apiClient = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Public requests (quote, booking, enquiry) — no credentials so CORS accepts
// wildcard Access-Control-Allow-Origin from the ingress.
export const publicApi = axios.create({
  baseURL: API,
  withCredentials: false,
});
